import Vue from 'vue';

let enabled = [];
let slotOrder = {};

function selectModules(template, sharedModules) {
    const picked = sharedModules.filter(m =>
        (!template.modules || template.modules.includes(m.id)) && !template.exclude.includes(m.id)
    );
    return [...picked, ...template.localModules];
}

function warnMissingDependencies(list) {
    if (process.env.NODE_ENV === 'production') return;
    const ids = new Set(list.map(m => m.id));
    list.forEach(m => m.requires
        .filter(dep => !ids.has(dep))
        .forEach(dep => console.warn(`[module] "${m.id}" requires "${dep}", which is not enabled`)));
}

function isVisible(item, ctx) {
    if (item.auth && !ctx.loggedIn) return false;
    if (item.guest && ctx.loggedIn) return false;
    return item.when ? item.when(ctx) : true;
}

export const modules = {
    has(id) {
        return enabled.some(m => m.id === id);
    },

    routes() {
        return enabled.flatMap(m => m.routes);
    },

    // Items contributed to an extension point, ordered by the template's
    // `slots` config when present, otherwise by `order`.
    items(slot, ctx) {
        let list = enabled.flatMap(m => m.contributes[slot] || []);
        const keys = slotOrder[slot];
        if (keys) {
            list = keys.map(key => list.find(item => item.key === key)).filter(Boolean);
        } else {
            list = [...list].sort((a, b) => (a.order ?? 100) - (b.order ?? 100));
        }
        return ctx ? list.filter(item => isVisible(item, ctx)) : list;
    }
};

export function installModules(template, sharedModules) {
    enabled = selectModules(template, sharedModules);
    slotOrder = template.slots;
    warnMissingDependencies(enabled);
    Vue.prototype.$modules = modules;
}

export default modules;
